/* Editorial grid galleries in carousels. Native theme components own quick buy. */
(() => {
  if (customElements.get('lf-slider-grid-card')) return;
  customElements.define('lf-slider-grid-card', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const gallery = this.querySelector('[data-lf-card-gallery]');
        if (!gallery) return;
        const items = Array.from(gallery.querySelectorAll('[data-lf-gallery-item]'));
        if (items.length < 2) return;
        let current = Math.max(0, items.findIndex(item => item.classList.contains('is-active')));
        const render = index => {
          items.forEach((item, i) => item.classList.toggle('is-active', i === index));
          gallery.dataset.currentMedia = index;
        };
        for (const [selector, step] of [['[data-lf-gallery-prev]', -1], ['[data-lf-gallery-next]', 1]]) {
          gallery.querySelector(selector)?.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            current = (current + step + items.length) % items.length;
            render(current);
          }, options);
        }
        const hover = () => matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
        gallery.addEventListener('mouseenter', () => {
          if (hover() && current === 0) render(1);
        }, options);
        gallery.addEventListener('mouseleave', () => render(current), options);
        // Do not intercept touch gestures: the surrounding product-list owns swiping.
        render(current);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
